import React from "react";
import PageTemplate from "../../components/PageTemplate";
import SettingsMobileHeader from "../../components/Settings/SettingsMobileHeader";
import MobileSwitcher from "../../components/MobileSwitcher";
import SettingsMobile from "../../components/Settings/SettingsMobile";
import SettingsDesktop from "../../components/Settings/SettingsDesktop";

const SettingsHome = () => {
  return (
    <PageTemplate
      title="Settings"
      mobileHeader={<SettingsMobileHeader />}
      sidebarTitle="Settings"
      sidebarSubtitle={"It's all the little things that matter here."}
      centered
    >
      <MobileSwitcher
        mobileComponent={<SettingsMobile />}
        desktopComponent={<SettingsDesktop />}
      />
    </PageTemplate>
  );
};

export default SettingsHome;
